//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | 子系统(计分器等)统一授权券获取/缓存/静默续期
//  | 由 front-api 用主登录态换发短时访问令牌(JWT)，客户端不持有任何签名密钥
//  | 令牌绑定签发时的主登录token(owner)，主登录态变更(登出/换号)即失效，避免跨账号串号
//  +----------------------------------------------------------------------
import request from './request';
import Cache from './cache';
import { LOGIN_STATUS } from '../config/cache';

const tokenCache = {};
const inflight = {};
const SAFETY_MS = 60 * 1000;

function currentOwner() {
	return Cache.get(LOGIN_STATUS) || '';
}

function fetchToken(aud) {
	const owner = currentOwner();
	const promise = request.get('auth/subsystem-token', { aud }, {}).then((res) => {
		const data = (res && res.data) ? res.data : {};
		const expiresIn = Number(data.expiresIn) || 1800;
		tokenCache[aud] = {
			token: data.accessToken,
			owner: owner,
			expireAt: Date.now() + expiresIn * 1000 - SAFETY_MS
		};
		delete inflight[aud];
		return data.accessToken;
	}).catch((e) => {
		delete inflight[aud];
		return Promise.reject(e);
	});
	inflight[aud] = promise;
	return promise;
}

export function getSubsystemToken(aud, forceRefresh) {
	const cached = tokenCache[aud];
	if (!forceRefresh && cached && cached.token && cached.owner === currentOwner() && Date.now() < cached.expireAt) {
		return Promise.resolve(cached.token);
	}
	if (!forceRefresh && inflight[aud]) {
		return inflight[aud];
	}
	return fetchToken(aud);
}

export function clearSubsystemToken(aud) {
	if (aud) {
		delete tokenCache[aud];
	} else {
		Object.keys(tokenCache).forEach((k) => delete tokenCache[k]);
	}
}
